<template>
  <div
    v-if="order.expandDetail"
    :class="{
      'text-mini': isMobile,
      'pa-3': order.expandDetail && !isMobile,
      'px-3': !order.expandDetail && isMobile
    }"
  >
    <div class="py-2 px-3 pa-md-0 pb-md-3">
      {{
        $t(order.signupLottery ? "registration_overview" : "orderlist_overview")
      }}
    </div>
    <template v-if="!isMobile">
      <v-divider />
      <v-row no-gutters class="order-thead d-none d-md-flex">
        <template v-if="order.tickets[0].seatInfo.area">
          <v-col md="3"
            >{{ $t("orderlist_ticket_no") }}<br />
            <span class="text-mini">({{ $t("ent_tax_num") }})</span>
          </v-col>
          <v-col :md="!order.tickets[0].applicant ? 2 : 1">{{
            $t("orderlist_entry_no")
          }}</v-col>
          <v-col :md="!order.tickets[0].applicant ? 2 : 1">{{
            $t(
              !!order.signupLottery
                ? "registration_ticket_area"
                : "orderlist_ticketarea_name"
            )
          }}</v-col>
          <v-col md="2">{{ $t("orderlist_ticketarea_seat") }}</v-col>
          <v-col md="2">{{
            $t(
              order.signupLottery
                ? "registration_ticket_type"
                : "orderlist_product_name"
            )
          }}</v-col>
          <v-col md="1">{{ $t("orderlist_product_sum") }}</v-col>
          <v-col md="2" v-if="order.tickets[0].applicant">{{
            $t("userinfo_name")
          }}</v-col>
        </template>
        <template v-else>
          <v-col>
            {{ $t("orderlist_ticket_no") }}<br /><span class="text-mini"
              >({{ $t("ent_tax_num") }})</span
            >
          </v-col>
          <v-col :md="order.tickets[0].applicant ? '2' : '3'">{{
            $t("orderlist_serial_no")
          }}</v-col>
          <v-col :md="order.tickets[0].applicant ? '2' : '3'">{{
            $t(
              !!order.signupLottery
                ? "registration_ticket_type"
                : "orderlist_product_name"
            )
          }}</v-col>
          <v-col>{{ $t("orderlist_product_sum") }}</v-col>
          <v-col v-if="order.tickets[0].applicant">{{
            $t("userinfo_name")
          }}</v-col>
        </template>
      </v-row>
    </template>
    <template v-for="(ticket, index) in order.tickets">
      <v-divider />
      <template v-if="order.tickets[0].seatInfo.area">
        <v-row
          :key="`tickets-${index}`"
          no-gutters
          :class="`order-item ${ticket.voidTicket && !isMobile ? 'pt-8' : ''} `"
        >
          <div v-if="ticket.voidTicket" class="refund-tag">
            {{ ticket.voidTicket }}
          </div>
          <v-col cols="6" sm="6" md="3">
            <div :class="orderItemLabel">
              {{ $t("orderlist_ticket_no") }}
              <span class="text-mini">({{ $t("ent_tax_num") }})</span>
            </div>
            <span class="font-weight-bold">{{ ticket.ticketNum || "-" }}</span
            ><br />
            <small
              >({{ ticket.entTaxNum !== "" ? ticket.entTaxNum : "-" }})</small
            >
          </v-col>
          <v-col cols="6" sm="6" :md="ticket.applicant ? 1 : 2">
            <div :class="orderItemLabel">{{ $t("orderlist_serial_no") }}</div>
            {{ ticket.entrySN || "-" }}
          </v-col>
          <v-col cols="6" sm="6" :md="ticket.applicant ? 1 : 2">
            <div :class="orderItemLabel">
              {{ $t("orderlist_ticketarea_name") }}
            </div>
            {{ ticket.seatInfo.area || "-" }}
          </v-col>
          <v-col cols="6" sm="3" md="2" :class="{ 'mb-2': isMobile }">
            <div :class="orderItemLabel">
              {{ $t("orderlist_ticketarea_seat") }}
            </div>
            {{ ticket.seatInfo.seat || "-" }}
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="2"
            :class="{ 'mb-2': isMobile && ticket.applicant }"
          >
            <div :class="orderItemLabel">
              {{ $t("orderlist_product_name") }}
            </div>
            {{ ticket.productName }}
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="1"
            :class="{ 'mb-2': isMobile && ticket.applicant }"
          >
            <div :class="orderItemLabel">{{ $t("orderlist_product_sum") }}</div>
            <span>
              NT.
              {{
                ticket.singlePrice
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </span>
          </v-col>
          <v-col
            v-if="ticket.applicant"
            cols="6"
            sm="6"
            md="2"
            :class="{ 'text-center': !isMobile }"
          >
            <div :class="orderItemLabel">{{ $t("userinfo_name") }}</div>
            <div
              class="d-flex align-center"
              :class="{
                'flex-column': !isMobile
              }"
            >
              {{ ticket.applicant.identityName }}
              <span
                role="button"
                class="accent-blue--text text-underline"
                :class="`m${!isMobile ? 't' : 'l'}-1`"
                @click="$emit('editApplicant', ticket, index)"
              >
                {{ $t("orderlist_applicant_detail") }}
              </span>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row
          :key="`tickets-${index}`"
          no-gutters
          :class="`order-item ${ticket.voidTicket && !isMobile ? 'pt-8' : ''} `"
        >
          <div v-if="ticket.voidTicket" class="refund-tag">
            {{ ticket.voidTicket }}
          </div>
          <v-col cols="6" sm="6" md="3">
            <div :class="orderItemLabel">
              {{ $t("orderlist_ticket_no")
              }}<span class="text-mini">({{ $t("ent_tax_num") }})</span>
            </div>
            <span class="font-weight-bold">{{ ticket.ticketNum || "-" }}</span
            ><br />
            <small
              >({{ ticket.entTaxNum !== "" ? ticket.entTaxNum : "-" }})</small
            >
          </v-col>
          <v-col cols="6" sm="6" md="3">
            <div :class="orderItemLabel">{{ $t("orderlist_entry_no") }}</div>
            {{ ticket.entrySN || "-" }}
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="3"
            :class="{ 'mb-2': isMobile && ticket.applicant }"
          >
            <div :class="orderItemLabel">
              {{ $t("orderlist_product_name") }}
            </div>
            {{ ticket.productName }}
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="3"
            :class="{ 'mb-2': isMobile && ticket.applicant }"
          >
            <div :class="orderItemLabel">{{ $t("orderlist_product_sum") }}</div>
            <span
              >NT.
              {{
                ticket.singlePrice
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span
            >
          </v-col>
          <v-col
            v-if="ticket.applicant"
            cols="6"
            sm="6"
            md="3"
            :class="{ 'text-center': !isMobile }"
          >
            <div :class="orderItemLabel">{{ $t("userinfo_name") }}</div>
            <div
              class="d-flex align-center"
              :class="{
                'flex-column': !isMobile
              }"
            >
              {{ ticket.applicant.identityName }}
              <span
                role="button"
                class="accent-blue--text text-underline"
                :class="`m${!isMobile ? 't' : 'l'}-1`"
                @click="$emit('editApplicant', ticket, index)"
              >
                {{ $t("orderlist_applicant_detail") }}
              </span>
            </div>
          </v-col>
        </v-row>
      </template>
    </template>
    <div class="grey lighten-2 rwd-margin font-weight-bold">
      <v-row class="py-2" no-gutters>
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{
            $t(!!order.signupLottery ? "registration_fee" : "tickets_summary")
          }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div>
            NT.{{
              order.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0
            }}
          </div>
        </v-col>
      </v-row>
      <v-row class="py-2" no-gutters v-if="order.isWelfareFeeOrder">
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{ $t("ticket_table_welfare") }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div>
            NT.{{
              order.welfareFee
                ? order.welfareFee
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : "0"
            }}
          </div>
        </v-col>
      </v-row>
      <v-row class="py-2" no-gutters v-if="order.culturePointDeductAmount">
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{ $t("orderlist_culturepoint_discount") }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div>
            <span>-NT.{{ order.culturePointDeductAmount }}</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="py-2" no-gutters>
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{ $t("orderlist_discount") }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div>
            -<span v-if="order.discount">NT.{{ order.discount }}</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="py-2" no-gutters>
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{ $t("orderlist_post_price") }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div>
            {{ order.shippingFee ? `NT.${order.shippingFee}` : "-" }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer class="d-none d-md-block" />
        <v-col cols="12" md="5">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="py-2" no-gutters>
        <v-spacer class="d-none d-md-block" />
        <v-col
          cols="6"
          md="6"
          class="pl-3"
          :class="{ 'text-right pr-10': !isMobile }"
        >
          {{ $t("orderlist_total") }}
        </v-col>
        <v-col cols="6" md="2" class="text-right pr-3 text-md-center pa-0">
          <div class="primary-1--text">
            NT.
            {{
              order.totalAmount
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0
            }}
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="pt-2 pt-md-3" v-if="order.culturePointDeductAmount">
      {{ $t("growup_benefit") }}
      <span class="order-detail-content">
        文化幣 折抵 {{ order.culturePointDeductAmount || "-" }}元
      </span>
    </div>
    <template v-if="order.couponContent">
      <div class="py-2 px-3 py-md-3">
        {{ $t("orderlist_sale_discount") }}
        <span class="order-detail-content">
          {{ order.couponContent || "-" }}
        </span>
      </div>
      <v-divider />
    </template>
    <div
      :class="
        `d-flex py-2 px-3 ${order.shippingType === 'post' ? 'pb-0' : 'py-md-3'}`
      "
    >
      <div class="text-no-wrap">{{ $t("orderlist_get_type") }}</div>
      <div class="ml-3">
        <span class="font-weight-bold">
          {{ pickupTypeText(order.shippingType) }}
          <template v-if="order.shippingPostInfo.shippingPostUrl !== ''">
            :
            <a :href="order.shippingPostInfo.shippingPostUrl" target="_blank">{{
              order.shippingPostInfo.shippingPostName
            }}</a>
          </template>
        </span>

        <div
          :class="pickNote"
          v-if="['ibon'].includes(order.shippingType)"
          v-html="
            order.ibonPickDateTime === ''
              ? $t('order_ibon_pickup_notification', {
                  pickCode: order.pickCode || '-'
                })
              : $t('order_ibon_pickup_deadline_notification', {
                  pickCode: order.pickCode || '-',
                  period: order.ibonPickDateTime || '-'
                })
          "
        ></div>
        <div
          :class="`${pickNote} mt-1`"
          v-if="
            order.shippingType === 'post' &&
              order.shippingPostInfo.shippingPostUrl !== ''
          "
        >
          {{ order.shippingPostInfo.shippingPostNum }}
          <v-icon
            color="primary-1"
            role="button"
            small
            @click="() => this.doCopy(order.shippingPostInfo.shippingPostNum)"
            >mdi-content-copy</v-icon
          >
        </div>
        <div
          :class="pickNote"
          v-if="['famiport'].includes(order.shippingType)"
          v-html="
            $t('orderlist_pickcode_notification', {
              pickCode: order.pickCode || '-'
            })
          "
        ></div>
      </div>
    </div>
    <div class="d-flex py-2 px-3 py-md-3" v-if="order.shippingType === 'post'">
      <!-- <div class="text-no-wrap">{{ $t("orderlist_get_type") }}</div> -->
      <div class="text-no-wrap">{{ $t("order_detail_shipping_info") }}</div>
      <div class="ml-3">
        <div>
          {{ order.shippingPostInfo.receiverMaskedName }}
        </div>
        <div>
          {{ order.shippingPostInfo.maskedMobile }}
        </div>
        <div>
          {{
            order.shippingAddress.postalCode +
              order.shippingAddress.county +
              order.shippingAddress.district +
              order.shippingAddress.address
          }}
        </div>
      </div>
    </div>
    <template v-if="!isReserverd && order.deliverSerialNo.length">
      <v-divider />
      <div class="d-flex justify-start py-2 px-3 py-md-3">
        <div class="d-inline-block">
          {{ $t("orderlist_deliver_serial_no") }}
        </div>
        <div class="d-inline-block ml-4">
          <div
            v-for="(serialNo, i) in order.deliverSerialNo"
            :key="`applicant-tickets-${i}`"
          >
            <div class="red--text">{{ serialNo }}</div>
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="
        order.transType && order.transType !== '' && order.transType !== 'FREE'
      "
    >
      <v-divider />
      <div class="d-flex py-2 px-3 py-md-3">
        <div>{{ $t("orderlist_payment") }}</div>
        <span class="order-detail-content">
          {{ transTypeText(order.transType) }}
        </span>
      </div>
    </template>
    <template v-if="!isReserverd">
      <v-divider
        v-if="
          (order.receiptType && order.receiptType !== '') ||
            order.invoiceNum !== ''
        "
      />
      <div
        class="py-2 px-3 py-md-3 d-flex"
        v-if="order.receiptType && order.receiptType !== ''"
      >
        {{ $t("orderlist_receipt") }}
        <span class="order-detail-content">
          {{ receiptTypeText(order.receiptType) }}
        </span>
      </div>
      <div v-if="hasInvoice" class="py-2 px-3 py-md-3 d-flex">
        {{ $t("orderlist_receipt_no") }}
        <span class="order-detail-content">
          <template v-if="order.invoiceNum">
            {{ order.invoiceNum }}
          </template>
          <template v-if="order.invoiceNumForPost">
            <br v-if="order.invoiceNum" />
            {{ order.invoiceNumForPost }}({{ $t("orderlist_post_price") }})
          </template>
          <template v-if="order.invoiceNumForWelfareFee">
            <br v-if="order.invoiceNum || order.invoiceNumForPost" />
            {{ order.invoiceNumForWelfareFee }}({{
              $t("ticket_table_welfare")
            }})
          </template>
        </span>
      </div>
      <div class="px-3 pb-2 d-flex" v-if="order.receiptType == 'donate'">
        {{ $t("orderlist_donation_organizer") }}
        <span class="order-detail-content">
          {{
            donateOrganizations.find(
              o => o.code == order.receiptContent.organization
            ).name || "-"
          }}
        </span>
      </div>
      <div class="py-2 px-3 pa-0" v-if="order.receiptType == 'duplicate'">
        {{ $t("orderlist_receiver_name") }}
        <span class="order-detail-content">
          {{ order.receiptContent.name || order.receiptContent.maskedName }}
        </span>
      </div>
      <div
        class="d-flex align-start py-2 px-3 py-md-3"
        v-if="order.receiptType == 'duplicate'"
      >
        <div class="text-no-wrap">{{ $t("orderlist_receiver_address") }}</div>
        <span class="order-detail-content d-inline-block">
          {{
            order.receiptContent.county +
              order.receiptContent.district +
              order.receiptContent.address
          }}<br />
          <span class="primary-1--text text-body-2 font-weight-medium">{{
            $t("order_invoice_notefication")
          }}</span>
        </span>
      </div>
      <div class="py-2 px-3 pa-0" v-if="order.receiptType == 'triplicate'">
        {{ $t("orderlist_corp_name") }}
        <span class="order-detail-content">
          {{ order.receiptContent.organization }}
        </span>
      </div>
      <div class="py-2 px-3 py-md-3" v-if="order.receiptType == 'triplicate'">
        {{ $t("orderlist_corp_number") }}
        <span class="order-detail-content">
          {{ order.receiptContent.taxIdNumber }}
        </span>
      </div>
    </template>
    <template
      v-if="!['待繳費', '付款失敗', '無需付款'].includes(order.payStatus)"
    >
      <div class="py-2 px-3 pa-0">
        <v-divider class="mb-2" />
        {{ $t(!!order.signupLottery ? "cancel_apply" : "redund_application") }}
        <span class="order-detail-content">
          <v-btn
            v-if="isMobile"
            outlined
            depressed
            color="primary-2"
            class="is-narrow"
            @click="
              () => {
                $router
                  .push({
                    name: 'OrderRefund',
                    params: { orderNum: order.orderNum }
                  })
                  .catch();
              }
            "
            >{{ $t(!!order.signupLottery ? "go_cancellation" : "go_apply") }}
          </v-btn>
          <v-btn
            v-else
            outlined
            depressed
            color="primary-2"
            class="is-narrow"
            large
            @click="
              () => {
                $router
                  .push({
                    name: 'OrderRefund',
                    params: { orderNum: order.orderNum }
                  })
                  .catch();
              }
            "
            >{{ $t(!!order.signupLottery ? "go_cancellation" : "go_apply") }}
          </v-btn>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import donateOrganizationJS from "@/static/donateOrganization.js";
import { template } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    order: {
      type: Object
    },
    isReserverd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    orderItemLabel() {
      return "d-block d-md-none primary-1--text";
    },
    pickNote() {
      return `primary-1--text font-weight-medium ${
        this.isMobile ? "text-mini" : "text-body-2"
      }`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    donateOrganizations() {
      return donateOrganizationJS;
    },
    hasInvoice() {
      const {
        invoiceNum,
        invoiceNumForPost,
        invoiceNumForWelfareFee
      } = this.order;
      return (
        invoiceNum !== "" ||
        invoiceNumForPost !== "" ||
        invoiceNumForWelfareFee !== ""
      );
    }
  },
  methods: {
    ...mapActions({
      setCurrentOrder: "order/setCurrentOrder"
    }),
    doCopy(num) {
      navigator.clipboard.writeText(num).then(
        function() {},
        function() {}
      );
    },
    goPayment(order, repay) {
      this.setCurrentOrder(order);
      this.$router
        .push({
          name: "OrderedPayment",
          params: { orderNum: order.orderNum },
          query: { repay }
        })
        .catch(() => {});
    },
    pickupTypeText(type) {
      let str = "";
      switch (type) {
        case "serial":
          str = this.$t("orderlist_serial_pickup");
          break;
        case "famiport":
          str = this.$t("orderlist_fami_pickup");
          break;
        case "ibon":
          str = this.$t("orderlist_ibon_pickup");
          break;
        case "post":
          str = this.$t("orderlist_post_pickup");
          break;
        case "eTicket":
          str = this.$t("eticket");
          break;
        case "":
        case "none":
          str = this.$t("orderlist_no_pickup");
          break;
        default:
          str = "-";
      }
      return str;
    },
    transTypeText(type) {
      let str = "";
      switch (type) {
        case "ATM":
          str = this.$t("orderlist_virtual_account");
          break;
        case "CC":
          str = this.$t("orderlist_card_payment_one_time");
          break;
        default:
          str = "-";
      }
      return str;
    },
    receiptTypeText(type) {
      let str = "";
      switch (type) {
        case "donate":
          str = this.$t("orderlist_donate_receipt");
          break;
        case "duplicate":
          str = this.$t("orderlist_personal_receipt");
          break;
        case "triplicate":
          str = this.$t("orderlist_corp_receipt");
          break;
        default:
          str = "-";
      }
      return str;
    },
    receiptAddress(receiptContent) {
      let address =
        receiptContent.county +
        receiptContent.district +
        receiptContent.address;
      return `********${address.substring(8, address.length)}`;
    },
    countDeductAmount(tickets) {
      return tickets.reduce(
        (debuct, ticket) =>
          !!ticket.culturePointTicketDeductAmount
            ? debuct + ticket.culturePointTicketDeductAmount
            : 0,
        0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.text-mini {
  font-size: 14px;
  font-weight: 400;
}

.order-thead {
  > div {
    text-align: center;
    font-weight: 600;
    padding: 8px 0 !important;
    line-height: 1.25;
    align-content: center;
  }
}

.order-item {
  position: relative;
  padding: 12px;
  padding-left: 0;
  padding-right: 0;

  .refund-tag {
    position: absolute;
    color: white;
    text-align: center;
    width: 72px;
    height: 28px;
    background-color: #ff0032;
    left: 0;
    top: 0;
  }

  @media screen and (max-width: 960px) {
    padding-left: 12px;
    padding-right: 12px;

    .refund-tag {
      right: 0;
      left: auto;
    }
  }

  .text-underline {
    text-decoration: underline;
  }

  > div {
    text-align: center;
    padding: 4px 0 !important;
    line-height: 1.25;
    align-content: center;

    .text-mini {
      font-weight: 400;
    }

    @media screen and (max-width: 960px) {
      text-align: left;
    }
  }
}

.order-detail-content {
  margin-left: 12px;
  font-weight: 600;
}
</style>
